<template>
  <div class="main">
    <c-panel title="Tipos de usuário do transporte" titleIcon="fas fa-users">
      <!--
        Item 9: "registrar os tipos de usuários do transporte escolar".

        `origem_pessoa` diz de qual cadastro a pessoa vem — aluno ou servidor. É o que permite
        o item 23 (professores) sem criar um terceiro cadastro de pessoa.
      -->
      <crud-simples endpoint="api/transporte-escolar/tipo-usuario" :perfis-escrita="[0, 1, 4, 5, 6, 12]" rotuloNovo="NOVO TIPO"
                    nomeSingular="tipo de usuário" placeholderBusca="Pesquisar por nome"
                    :campos="campos" :colunas="colunas"></crud-simples>
    </c-panel>
  </div>
</template>

<script>
import CrudSimples from '@/shared/crud-simples/crud-simples.vue'

const ORIGENS = [{ valor: 'aluno', rotulo: 'Aluno' }, { valor: 'servidor', rotulo: 'Servidor' }]

export default {
  components: { CrudSimples, cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    campos: [
      { chave: 'nome', label: 'Nome', obrigatorio: true, span: 12, max: 60 },
      { chave: 'origem_pessoa', label: 'Origem da pessoa', tipo: 'select', obrigatorio: true,
        opcoes: ORIGENS, padrao: 'aluno', span: 12 },
      { chave: 'exige_matricula', label: 'Exige matrícula', tipo: 'switch', span: 12 }
    ],
    colunas: [
      { chave: 'nome', label: 'Nome' },
      { chave: 'origem_pessoa', label: 'Origem', largura: '140px',
        mapa: { aluno: 'Aluno', servidor: 'Servidor' } },
      { chave: 'exige_matricula', label: 'Exige matrícula', largura: '150px', booleano: true, mobileOculto: true }
    ]
  })
}
</script>
